import Class from '@core/Class';
import FilteredSearch from '@modules/filter/simpleListFilter';
import Module from '@core/Module';
import Events from '@core/Events';

import {jqueryScrolling, jqueryHighlight} from '@modules/lazy-imports';

var init = async function () {

        Promise.all( [
            jqueryScrolling(),
            jqueryHighlight()
        ] );

        // handle custom printing module
        this.disabled = false;

        var self = this;
        $( this.proxy( function () {
            // wrap address lists in order to prepend filter form when needed
            this.address_containers.find( '.addresses' ).wrap( '<div class="addressList"></div>' ).show();
            this.update_elements();

            this.address_lists.hide();

            // lazy load address filters only once per address list
            this.address_lists.each( function ( i, list ) {
                var $list = $( list );

                $list.on( 'addresslist:open addresslist:close', function ( data ) {
                    data.list.parent( '.module' ).scrollToElement();
                } )

                $list.one( 'addresslist:open', function () {
                    if ( $list.find( 'address' ).length > 9 ) {
                        var addressFilter = new FilteredSearch( $list.find( 'ul' ), {
                            label: 'Filter Addresses',
                            hint: 'Anaheim, 90620, or Clementine St',
                            placeholder: 'City, ZIP Code, or Street Name'
                        } );

                        $list.on( 'addresslist:close', function ( e ) {
                            addressFilter.clearResults();
                            addressFilter.blur();
                        } );
                        $list.on( 'addresslist:open', function ( e ) {
                            addressFilter.focus();
                        } );
                    }
                } );
            } );

        } ) );

    },

    toggle_buttons = function ( label, doDisable ) {
        doDisable = (typeof doDisable !== 'undefined')
            ? doDisable
            : true;

        this.disabled = doDisable;

        $.each( [
            this.shipping_buttons, this.shipping_address_buttons
        ], function ( i, item ) {
            item[doDisable
                ? 'addClass'
                : 'removeClass']( 'disabled' );
        } );

        if ( label ) {
            label.target.attr( 'value', label.text );
        }
    },

    handle_address_change = function ( e ) {
        var $button = $( e.currentTarget ),
            $list = $button.siblings( '.addressList:first' );

        this.toggle_address_list( $list );
    },

    toggle_address_list = function ( $list ) {
        var isVisible = $list.is( ':visible' );

        $list[isVisible
            ? 'slideUp'
            : 'slideDown']( 200 ).siblings( '.button' ).text( isVisible
            ? 'Change'
            : 'Cancel' );

        $list.trigger( {
            type: 'addresslist:' + (!isVisible
                ? 'open'
                : 'close'),
            list: $list
        } );
    },

    select_address_item = function ( e ) {
        var $selectedAddress = $( e.currentTarget ),
            $address = $( '#' + $selectedAddress.attr( 'name' ) + 'Address' );

        $selectedAddress.parents( 'li' ).find( 'address span' ).each( function ( i, field ) {
            var $field = $( field );
            $address.find( '.' + $field.attr( 'class' ) ).text( $field.text() );
        } );

        $address.highlight( '#fff9e4' );

        this.toggle_address_list( $address.next() );
    };

const AddressModule = Class.extend( $.extend( {

    events: {
        'click change_address_buttons': 'handle_address_change',
        'change address_inputs': 'select_address_item'
    },

    elements: {
        '#billingAddressContainer input[type="radio"]': 'billing_address_buttons',
        '#shippingAddressContainer input[type="radio"]': 'shipping_address_buttons',
        '#billingAddressContainer, #shippingAddressContainer': 'address_containers',
        '.addressList': 'address_lists',
        '.module .button[title="Change"]': 'change_address_buttons',
        '.module .addresses input[type="radio"]': 'address_inputs'
    },

    init: init,
    toggle_buttons: toggle_buttons,
    toggle_address_list: toggle_address_list,
    select_address_item: select_address_item,
    handle_address_change: handle_address_change

}, Module, Events ) );

$( function () {
    new AddressModule( document.querySelector( '#body-content' ) );
} )
